import type { BackendEnvironment } from '@core/environment-legacy';

export const RECRUITEE_BACKEND = (<const>{
  protocol: 'https',
  referralsProtocol: 'https',
  domain: 'api.recruitee.internal:4000',
  partialDomain: 'recruitee.internal',
  referralsPartialDomain: 'testtalentpool.referrals.local:3004',
  apiUrl: 'https://api.recruitee.internal:4000',
  authUrl: 'https://auth.recruitee.internal:4010',
  appUrl: 'https://recruitee.com:4000',
  webAppUrl: 'https://app.recruitee.internal:3003',
  mobileAppUrl: 'https://mobile.recruitee.internal:3100',
  wsUrl: 'wss://api.recruitee.internal:4000/socket',
  widgetUrl: 'https://recruitee.github.io/widget/demos/widget.js',
  widgetApiEndpoint: 'https://career.s.recruitee.com/api/c',
  videoAppUrl: 'https://video.s.recruitee.com',
  CDNHost: 'https://app.s.recruitee.com',
  pdfViewerDirectory: 'pdfjs-patched-staging',
  integrationsUrl: 'https://integrations.recruitee.internal:5500',
  tellentApiUrl: 'https://api.tellent.internal:5700',
  tellentAuthUrl: 'https://auth.tellent.internal:5710',
  tellentAppUrl: 'https://admin.tellent.internal:3006',
  tellentAppWsUrl: 'wss://api.tellent.internal:5700/socket',
  tellentOneDomainUrl: 'https://app.tellent.internal:3006',
  reportsApiUrl: 'https://analytics.tellent.internal:4200',
}) satisfies BackendEnvironment;
